(function () {
    const modal = document.getElementById('product-modal');
    if (!modal) return;

    const openBtns = [
        document.getElementById('product-inquiry-btn'),
        document.getElementById('product-inquiry-btn-mobile')
    ].filter(Boolean);

    const closeEls = modal.querySelectorAll('[data-modal-close]');
    const body = document.body;

    function collectSpecs() {
        const product = (document.querySelector('.product-hero__title') || document.querySelector('h1'))?.textContent.trim() || document.title;

        const specs = { product };

        const hasTurntableSel = document.querySelector('[data-select-id="has-turntable"] .custom-select__trigger span');
        if (hasTurntableSel) {
            specs['has-turntable'] = hasTurntableSel.textContent.trim();
        }

        const allSelects = document.querySelectorAll('.product-info__config [data-select-id]');
        allSelects.forEach(select => {
            const selectId = select.getAttribute('data-select-id');
            if (selectId && selectId !== 'has-turntable') {
                const trigger = select.querySelector('.custom-select__trigger span');
                if (trigger) {
                    specs[selectId] = trigger.textContent.trim();
                }
            }
        });

        return specs;
    }

    function fillSummaryInModal() {
        const specs = collectSpecs();

        const hasTurntableEl = modal.querySelector('#pm-has-turntable');
        if (hasTurntableEl && specs['has-turntable']) {
            hasTurntableEl.textContent = specs['has-turntable'];
        }

        const allModalParams = modal.querySelectorAll('.product-modal__meta [id^="pm-"]');
        allModalParams.forEach(el => {
            const id = el.id;
            const paramKey = id.replace('pm-', '');
            if (specs[paramKey]) {
                el.textContent = specs[paramKey];
            }
        });
    }

    function fillHiddenInputs() {
        const form = modal.querySelector('form.wpcf7-form');
        if (!form) return;
        const specs = collectSpecs();

        const set = (id, val) => {
            const el = form.querySelector('#' + id);
            if (el) el.value = val || '';
        };

        set('product_title', specs.product);
        set('source_url', window.location.href);

        const paramsList = [];

        if (specs['has-turntable']) {
            paramsList.push(`Obrotnica: ${specs['has-turntable']}`);
        }

        Object.keys(specs).forEach(key => {
            if (key !== 'product' && key !== 'has-turntable') {
                const selectElement = document.querySelector(`[data-select-id="${key}"]`);
                const label = selectElement?.closest('.product-info__field')?.querySelector('.product-info__label')?.textContent.trim() || key;
                paramsList.push(`${label}: ${specs[key]}`);
            }
        });

        set('parameters', paramsList.join(', '));
    }

    function open() {
        fillSummaryInModal();
        modal.classList.add('is-open');
        modal.setAttribute('aria-hidden', 'false');
        body.style.overflow = 'hidden';
        document.documentElement.style.overflow = 'hidden';
        setTimeout(fillHiddenInputs, 50);
        modal._preventScroll = (e) => e.preventDefault();

    }

    function close() {
        modal.classList.remove('is-open', 'show-thanks');
        modal.setAttribute('aria-hidden', 'true');
        body.style.overflow = '';
        document.documentElement.style.overflow = '';
        const thanks = modal.querySelector('.product-modal__thanks');
        const dialog = modal.querySelector('.product-modal__dialog');

        const formWrap = modal.querySelector('.product-modal__form');
        if (thanks && formWrap) {
            thanks.hidden = true;
            formWrap.hidden = false;
        }
        if (dialog) dialog.style.display = '';
        if (modal._preventScroll) {
            document.removeEventListener('touchmove', modal._preventScroll, { capture: true });
            modal._preventScroll = null;
        }
    }
    document.addEventListener('click', (e) => {
        const btn = e.target.closest('#product-inquiry-btn, #product-inquiry-btn-mobile');
        if (!btn) return;

        e.preventDefault();
        open();
    });

    closeEls.forEach(el => el.addEventListener('click', close));

    document.addEventListener('keydown', e => {
        if (e.key === 'Escape' && modal.classList.contains('is-open')) close();
    });

    modal.querySelector('.product-modal__overlay')?.addEventListener('click', close);

    document.addEventListener('wpcf7mailsent', function (event) {
        if (!modal.contains(event.target)) return;

        modal.classList.add('show-thanks');

        const formWrap = modal.querySelector('.product-modal__form');
        const thanks = modal.querySelector('.product-modal__thanks');

        if (formWrap && thanks) {
            formWrap.hidden = true;
            thanks.hidden = false;

            const dialog = modal.querySelector('.product-modal__dialog');
            if (dialog) dialog.style.display = 'none';
        }

        const response = modal.querySelector('.wpcf7-response-output');
        if (response) response.style.display = 'none';
    });
})();
